

// 29029 ID cookie

document.addEventListener("DOMContentLoaded", async function () {
  let cookie = getCookie('_29029_id');
  if (cookie) {
    let target = document.querySelector('input[name="id"]');
    if (target) {
      let newInput = document.createElement('input');
      newInput.type = 'hidden';
      newInput.name = 'attributes[_29029_id]';
      newInput.value = cookie;
      target.parentNode.insertBefore(newInput, target);
    }
  }
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}